import type { LessThanExpression } from '@trackback/widgets';
import { createSimpleNamedExpressionResolver } from '../types';

export const lessThanResolver =
  createSimpleNamedExpressionResolver<LessThanExpression>(
    'lessThan',
    (value, other) => value < other
  );
